import { BillingEventData } from '@/common/types/billing/event.type'
import { formatCardNumber, formatCurrency, formatDateTime, formatDecimal, formatUnit } from '@/common/utils/formatters'
import CompanyEventAuthor from '@/features/privateCompanies/components/companyEventAuthor'
import CompanyEventTotalFee from '@/features/privateCompanies/components/companyConsumptionTotalFee'
import {
  eventableDetailsComponent,
  eventableTypeTranslations,
} from '@/features/privateCompanies/services/companyBillingEventTransformer'
import { UserEventData } from '@/features/privateCompanies/types/userEvents.type'
import { createElement } from 'react'
import { eventableStatus } from '../constants/events/eventableStatus.constant'
import { cn } from '@/common/utils/cn'

export class UserEventsTransformer {
  static tableTransformer() {
    return (userEvents: UserEventData[]) => {
      return userEvents.map((userEvent) => {
        const clientBranch = userEvent.eventable?.client_branch?.display_name
          || userEvent.eventable?.client_branch?.general_information?.fantasy_name
          || userEvent.eventable?.company_fantasy_name
          || ''

        const eventStatus = userEvent?.status as keyof typeof eventableStatus;

        return {
          _className: cn(
            userEvent.eventable_type === 'Billing::Refund' && 'bg-danger-op',
            eventStatus === 'pending' && 'bg-yellow-op-2',
          ),
          status: eventableStatus[eventStatus] || eventStatus,
          protocol_number: userEvent.protocol_number ? `${userEvent.protocol_number}` : '',
          bill: 'Não implementado',
          type: userEvent.eventable_type ? eventableTypeTranslations[userEvent.eventable_type] : '',
          details: eventableDetailsComponent[userEvent.eventable_type]
            ? createElement(eventableDetailsComponent[userEvent.eventable_type], { data: userEvent.eventable })
            : '',
          total_amount: userEvent.eventable?.total_amount
            ? formatCurrency(userEvent.eventable?.total_amount)
            : '',
          fee_total: userEvent.fee_total
            ? createElement(CompanyEventTotalFee, { data: userEvent as unknown as BillingEventData })
            : '',
          income_tax_total_amount: userEvent.income_tax_total ? formatCurrency(Number(userEvent.income_tax_total)) : '',

          client_branch_name: clientBranch,

          card: userEvent.eventable.card.last_four_digits
            ? formatCardNumber(userEvent.eventable.card.last_four_digits)
            : '',
          current_equipment_usage: userEvent?.eventable?.current_equipment_usage
            ? formatUnit(formatDecimal(userEvent?.eventable?.current_equipment_usage, 0), 'kilometers')
            : '',
          author: userEvent.author
            ? createElement(CompanyEventAuthor, { data: userEvent.author })
            : '',
          created_at: userEvent.created_at ? formatDateTime(new Date(userEvent.created_at)) : '',
        }
      })
    }
  }
}
